import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Topbar from '../components/Topbar';
import api from '../api';

const COLORS = ['#066ac9','#0cbc87','#f7c32e','#d6293e','#6f42c1','#fd7e14','#17a2b8'];

function getIsAdmin() {
  try { return !!(JSON.parse(localStorage.getItem('enseignant') || '{}').is_admin); } catch { return false; }
}

export default function Classes() {
  const [classes, setClasses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ nom: '', niveau: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const isAdmin = getIsAdmin();

  useEffect(() => {
    api.get('/classes').then(r => setClasses(r.data));
  }, []);

  const handleCreate = async e => {
    e.preventDefault();
    if (!form.nom.trim()) { setError('Nom requis'); return; }
    setSaving(true);
    try {
      const { data } = await api.post('/classes', form);
      setClasses(c => [...c, { ...data, nb_eleves: 0 }]);
      setShowModal(false);
      setForm({ nom: '', niveau: '' });
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cette classe ?')) return;
    await api.delete(`/classes/${id}`);
    setClasses(c => c.filter(x => x.id !== id));
  };

  const handleDeleteAllEleves = async () => {
    if (!window.confirm('Supprimer TOUS les élèves de toutes les classes ? Cette action est irréversible.')) return;
    await api.delete('/eleves');
    const { data } = await api.get('/classes');
    setClasses(data);
  };

  return (
    <>
      <Topbar
        title="Classes"
        actions={
          <div className="d-flex gap-2">
            {isAdmin && (
              <button className="btn btn-outline-danger btn-sm" onClick={handleDeleteAllEleves}>
                <i className="bi bi-trash3 me-1"></i>Effacer tous les élèves
              </button>
            )}
            <button className="btn btn-primary" onClick={() => { setShowModal(true); setError(''); }}>
              <i className="bi bi-plus-lg me-2"></i>Nouvelle classe
            </button>
          </div>
        }
      />
      <div className="page-content">
        {classes.length === 0 ? (
          <div className="card">
            <div className="card-body text-center py-5 text-muted">
              <i className="bi bi-people" style={{ fontSize: '3rem', opacity: 0.2 }}></i>
              <p className="mt-3">Aucune classe. Créez vos classes ici avant de partager un formulaire — les élèves pourront sélectionner leur classe dans une liste déroulante.</p>
            </div>
          </div>
        ) : (
          <div className="row g-3">
            {classes.map((c, i) => (
              <div key={c.id} className="col-sm-6 col-xl-4">
                <div className="card h-100">
                  <div className="card-body">
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="avatar-sm" style={{ background: COLORS[i % COLORS.length], width: 48, height: 48, fontSize: '1.1rem', borderRadius: 12 }}>
                        {c.nom.charAt(0)}
                      </div>
                      <div>
                        <h6 className="mb-0 fw-semibold">{c.nom}</h6>
                        {c.niveau && <small className="text-muted">{c.niveau}</small>}
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <span className="text-muted" style={{ fontSize: '0.875rem' }}>
                        <i className="bi bi-person me-1"></i>{c.nb_eleves} élève{c.nb_eleves !== 1 ? 's' : ''}
                      </span>
                      <div className="d-flex gap-1">
                        {isAdmin && (
                          <button className="btn btn-sm btn-light text-danger" onClick={() => handleDelete(c.id)}>
                            <i className="bi bi-trash"></i>
                          </button>
                        )}
                        <Link to={`/classe/${c.id}`} className="btn btn-sm btn-primary">
                          Consulter
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.5)' }} onClick={() => setShowModal(false)}>
          <div className="modal-dialog" onClick={e => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Nouvelle classe</h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleCreate}>
                <div className="modal-body">
                  {error && <div className="alert alert-danger py-2">{error}</div>}
                  <div className="mb-3">
                    <label className="form-label fw-medium">Nom de la classe *</label>
                    <input className="form-control" value={form.nom} onChange={e => setForm({ ...form, nom: e.target.value })} placeholder="Ex: 3ème A" autoFocus />
                  </div>
                  <div>
                    <label className="form-label fw-medium">Niveau</label>
                    <input className="form-control" value={form.niveau} onChange={e => setForm({ ...form, niveau: e.target.value })} placeholder="Ex: 3ème" />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-light" onClick={() => setShowModal(false)}>Annuler</button>
                  <button type="submit" className="btn btn-primary" disabled={saving}>
                    {saving ? 'Création...' : 'Créer'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
